import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardMedia from '@material-ui/core/CardMedia';
import Button from '@material-ui/core/Button';

import Styles from "./CardImage.module.css";

const useStyles = makeStyles((theme) => ({
  root: {
    maxWidth: 345,
  },
  media: {
    height: 0,
    paddingTop: '56.25%', // 16:9
  },
  expand: {
    transform: 'rotate(0deg)',
    marginLeft: 'auto',
    transition: theme.transitions.create('transform', {
      duration: theme.transitions.duration.shortest,
    }),
  },
  expandOpen: {
    transform: 'rotate(180deg)',
  },
}));

const CardImage = (props) => {
  const classes = useStyles();
  const [expanded, setExpanded] = React.useState(false);

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return (
    <Card className={Styles["cardImage"]}>
      <CardMedia
        className={classes.media}
        // image="https://s3-alpha-sig.figma.com/img/9a94/cc6d/7507988bceeb132e91fc4105a8ac454e?Expires=1627257600&Signature=T5LK2O9pz6QzheBC~dO1bxNKxeqsUdz8z8LZCuiNUKJgPFN005wRtuHzf7D2kyUGk7leBY165qM87JVARpCmg1DS-tXjlkTkbvAzfG40stNAc6fep~hbzHPI-zX6183zPCFgtw1oAGd8m8XwG-HMXyimzNlBISjFhk1Wd9HqZjOMH0YVZd1rKCSr4qXwxFTQTNPdXXC-ksz3ItZDvbf-S7a3Y5NklzFA0sQLazxmUnqwwEqkAJyf0xO1cqB4V0HFqSpia-8u6vRKFA-xQuDF6UWanCVKi-mN5HqFCou6wmDgFmynoQ9uymPb-XdTza-sDhGzxbCgza4kd6dHhM6Dvw__&Key-Pair-Id=APKAINTVSUGEWH5XD5UA"
        image={props.img}
        title="card image"
      />
      <Button className={Styles["cardBtn"]} variant="contained" color="primary" onClick={props.onClick}>
        {props.btnTitle}
      </Button>
    </Card>
  );
};
export default CardImage;

